module.exports = __webpack_public_path__ + "img/slide10.98bef98d.jpg";